export const VossSubscriptionItemStatus = {
    Active: 0,
    Terminated: 1
}